import { render, staticRenderFns } from "./SimpleFrequencyCheck.vue?vue&type=template&id=1f3ac00d&scoped=true&"
import script from "./SimpleFrequencyCheck.vue?vue&type=script&lang=js&"
export * from "./SimpleFrequencyCheck.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFrequencyCheck.vue?vue&type=style&index=0&id=1f3ac00d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ac00d",
  null
  
)

export default component.exports